import { useEffect } from 'react'
import { useToastify } from '../../library/toastify/toast-provider';

export default function NetworkStatusMonitor() {

    const { showToastNotify } = useToastify();

    useEffect(() => {
        
        const handleOffline = () => {
            showToastNotify('No internet connection. Please check your network.', 'error');
        };

        const handleOnline = () => {
            showToastNotify('Internet connection restored.', 'success');
        };

        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);

        return () => {
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
        };
    }, [showToastNotify]);

    return null;
}